import { NgModule } from '@angular/core';
import { ItkSubnavComponent } from './subnav.component';

@NgModule({
  declarations: [ItkSubnavComponent],
  exports: [ItkSubnavComponent],
  imports: [],
})
export class ItkSubnavModule {}
